module.exports = __webpack_public_path__ + "img/QR-code.be9c1489.png";